
<template>
    <!-- 萤石猫眼列表 -->
    <div class="buttonlist">
      <div class="buttonlist-m">
        <el-form
          :inline="true"
          :model="queryForm"
          class="demo-form-inline toolbar"
          style="padding-bottom: 0px"
          @submit.native.prevent
        >
          <el-form-item label="设备编号">
            <el-input
              v-model.trim="queryForm.inputdeviceno"
              placeholder="请输入设备编号"
              clearable
              @keyup.enter.native.prevent="enterSearchMember"
            ></el-input>
          </el-form-item>
          <el-form-item label="绑定位置">
            <el-input
              v-model.trim="queryForm.location"
              placeholder="请输入绑定位置"
              clearable
              @keyup.enter.native.prevent="enterSearchMember"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              icon="el-icon-search" 
              plain
              @click="querySubmit"
              >查询</el-button>
          </el-form-item>
        </el-form>
        <div v-loading="loading" element-loading-text="拼命加载中......">
          <el-table
            :data="list"
            style="width: 100%"
            :row-style="tableRowStyle"
            :header-cell-style="tableHeaderColor"
          >
            <el-table-column
              label="设备编号"
              align="center"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <span style="margin-left: 10px">{{ scope.row.deviceNo }}</span>
              </template>
            </el-table-column>
          
            <el-table-column
              label="设备名称"
              :show-overflow-tooltip="true"
              align="center"
            >
              <template slot-scope="scope">
                <span style="margin-left: 10px">{{ scope.row.deviceName }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="设备描述"
              :show-overflow-tooltip="true"
              align="center"
            >
              <template slot-scope="scope">
                <span style="margin-left: 10px">{{ scope.row.remark }}</span>
              </template>
            </el-table-column>
  
            <el-table-column label="操作" width="350" align="center">
              <template slot-scope="scope">
                <el-button
                  type="success"
                  size="mini"
                  @click="handlePlay(scope.$index, scope.row)"
                  >播放</el-button
                >
                <el-button
                  type="primary"
                  size="mini"
                  plain
                  @click="handleEdit(scope.$index, scope.row)"
                  >编辑</el-button
                >
                <el-button
                  type="danger"
                  size="mini"
                  plain
                  @click="handleDelete(scope.$index, scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            background
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            layout="total, prev, pager, next"
            :total="totalDataNumber"
            :page-size="pageSize"
            align="center"
            class="fenye"
          ></el-pagination>
        </div>
        <!-- 弹出新增 -->
        <el-dialog
          :title="isAdd?'新增设备信息':'编辑设备信息'"
          :visible.sync="dialogFormVisible"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          class="dangerbuttonxz"
        >
          <el-form ref="form" :model="addForm" label-width="120px">
            <el-form-item
              label="设备编号"
              prop="deviceNo"
            >
              <el-input
                v-model.trim="addForm.deviceNo"
                placeholder="请输入设备编号"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="设备名称"
              prop="deviceName"
            >
              <el-input
                v-model.trim="addForm.deviceName"
                placeholder="请输入设备名称"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="设备描述"
              prop="remark"
            >
              <el-input
                v-model.trim="addForm.remark"
                type="textarea"
                :rows="3"
                placeholder="请输入设备描述"
              ></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer" align="center">
            <el-button @click=" dialogFormVisible = false ">取 消</el-button>
            <el-button
              type="primary"
              @click="submitAddForm"
              :loading="addLoading"
              >确 定</el-button
            >
          </div>
        </el-dialog>

        <!-- 弹出视频播放 -->
        <el-dialog
          title="视频播放"
          :visible.sync="playVisible"
          width="850px"
          style="margin-top: -11vh;"
          center
          class="playDialog"
        >
          <iframe
            :src="playUrl"
            width="800"
            height="600"
            id="ysOpenDevice"
            allowfullscreen
            v-if="playUrl"
          >
          </iframe>
          <span slot="footer" class="dialog-footer">
            <el-button @click="playVisible = false">关 闭</el-button>
          </span>
        </el-dialog>

      </div>
    </div>
  </template>
  <script>
  export default {
    data() {
      return {
        deviceType:63, //萤石猫眼列表
        addLoading: false,
        currentPage: 1, //初始页
        pageNum: 1, //页码
        pageSize: 10, //每页显示的条数
        list: [], //返回的结果集合
        allList: [], //返回紧急按钮的集合  全部数据
        totalDataNumber: 0, //数据的总数,
        loading: "", //加载数据中
        queryForm: {
          inputdeviceno: "",
          location: ""
        },
        // 新增表单dialog
        dialogFormVisible: false,
        isAdd:true,
        playUrl:"",
        playVisible:false,
        addForm: {
        },
        formLabelWidth: "120px",
      };
    },
    methods: {
      //键盘事件 按下键盘回车 查询
      enterSearchMember(e) {
        var keyCode = window.event ? e.keyCode : e.which;
        if (keyCode == 13) {
          this.querySubmit();
        }
      },
      //点击查询
      querySubmit() {
        this.getTableData(
            (this.pageNum = 1),
            (this.pageSize = 10)
        );
      },
      // 通道播放
      handlePlay(index, row) {
        // 获取播放地址
        let deviceSerial = row.deviceNo;
        let params = {
          deviceSerial: deviceSerial,
          code: "",
          channelNo:""
        };
        this.$postJson("dmc/cameraApi/getYSPlayUrl", params).then((res) => {
          if (res.code == 200) {
            console.log(res.result, "play");
            let play = res.result;
            console.log(play.url);
            console.log(play.accessToken);
            let playUrl = `https://open.ys7.com/ezopen/h5/iframe?url=${play.url}&autoplay=1&audio=1&accessToken=${play.accessToken}`;
            this.playUrl = playUrl;
            this.playVisible = true;
            console.log(playUrl, "playUrl");
          }
        });
        console.log(row, "row");
      },
      // 修改table tr行的背景色
      tableRowStyle({ row, rowIndex }) {
        if (rowIndex % 2 == 0) {
          return "background-color: #ffffff";
        } else {
          return "background-color: #e4f5f8";
        }
      },
      // 修改table header的背景色
      tableHeaderColor({ row, column, rowIndex, columnIndex }) {
        if (rowIndex === 0) {
          return "color:#2d2d2d;font-weight: 600; text-align: center;font-size: 16px;background-color: #d4f5fa;";
        }
      },
      showAddDialog(){
        this.dialogFormVisible = true;
        this.isAdd = true;
        this.addForm = {
          deviceNo:"",
          deviceName:"",
          remark:""
        }
        this.addLoading = false;
      },
  
      // 点击弹出修改信息的弹窗
      handleEdit(index, row) {
        this.dialogFormVisible = true;
        this.isAdd = false;
        this.addForm = {
          id: row.id,
          deviceNo: row.deviceNo,
          deviceName: row.deviceName,
          remark: row.remark
        }
        this.addLoading = false;
      },
      
      // 新增弹出框点击确定提交信息
      submitAddForm() {
        this.addLoading = true;
        let url = "dmc/commonDevice/add";
        if(!this.isAdd){
          url = "dmc/commonDevice/edit";
        }
        this.addForm.deviceType = this.deviceType;
        this.$postJson(url,this.addForm).then((res) => {
          this.addLoading = false;
          this.dialogFormVisible = false;
          this.$refs.form.resetFields(); //移除校验结果并重置字段值
          if (res.code == "200") {
            setTimeout(() => {
              this.$message({
                message: res.message,
                type: "success",
              });
              this.getTableData();
            }, 300);
          } else {
            setTimeout(() => {
              this.$message({
                message: res.message,
                type: "error",
              });
            }, 300);
          }
        });
      },
      //删除
      handleDelete(index, row) {
        if (row.status == null || row.status == true) {
          this.$confirm("此操作将永久删除该内容, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            center: true,
            closeOnClickModal: false,
          })
            .then(() => {
              this.$postJson("dmc/commonDevice/deleteById/"+row.id).then((res) => {
                if (res.code == 200) {
                  this.$message({
                    type: "success",
                    message: res.message,
                  });
                  this.getTableData();
                } else {
                  this.$message({
                    type: "error",
                    message: res.message,
                  });
                }
              });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消删除",
              });
            });
        } else {
          this.$message({
            type: "error",
            message: "该设备已经被绑定，请先解绑后再进行删除!",
          });
        }
      },
  
      //获取分页的紧急按钮数据  只获取pageSize条数据
      getTableData() {
        let param = {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          deviceNo: this.queryForm.inputdeviceno,
          location: this.queryForm.location,
          deviceType:this.deviceType
        };
        this.loading = true;
        this.$postJson("dmc/commonDevice/queryDeviceListWithPage", param).then(
          (res) => {
            //判断是否有数据
            if (res.result.list.length != 0) {
              this.pageSize = res.result.pageSize;
              this.currentPage = res.result.pageNum;
              this.totalDataNumber = res.result.total * 1;
              this.list = res.result.list;
              setTimeout(() => {
                this.loading = false;
              }, 200);
            } else {
              this.list = [];
              this.totalDataNumber = 0;
              setTimeout(() => {
                this.loading = false;
              }, 1000);
            }
          }
        );
      },
      handleCurrentChange(val) {
        this.pageNum = val;
        this.getTableData();
      },
    },
    created() {
      //组件创建完后获取数据，
      //此时 data 已经被 observed 了
      this.getTableData();
    },
    mounted() {
    },
  };
  </script>
  <style lang="scss" scoped>
  .buttonlist {
    .buttonlist-m {
      padding: 10px 0 0 5px;
    }
  }
  .fenye {
    margin: 0;
    padding: 30px 0;
    background: #fff;
  }
  </style>